function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { aiStatisticsConversationListApi, aiStatisticsConversationMessagesApi } from '@/api/aiStatistics';
import { markdownToHtml, looksLikeMarkdown } from '@/utils/aiMarkdown';

/**
 * 卡片封面等静态资源的域名。
 *
 * <p>cards_json 里存的是相对路径（如 {@code sjtximage/public/xxx.jpg}），直接塞给
 * el-image 会拼成相对当前后台域名的地址，必然 404。小程序端用的是
 * PUBLIC_ASSET_HOST，这里保持同一个域名；需要指向别的资源域时用环境变量覆盖。</p>
 */
var ASSET_HOST = (process.env.VUE_APP_ASSET_HOST || 'https://public-assets.shijitongxing.com').replace(/\/+$/, '');

/** 卡片类型 → 中文名。后端 schema 见 ai.card.v1。 */
var TYPE_LABELS = {
  activity: '集市活动',
  market: '集市场地',
  community_note: '摊友资讯',
  external_source: '外部来源',
  apply_summary: '报名统计',
  merchant_pending_apply: '商户待审核',
  permission_denied: '权限不足',
  unsupported_action: '不支持的操作',
  confirmation_card: '待确认操作',
  archive_selector: '报名档案',
  archive_list: '报名档案',
  archive_form: '报名档案',
  form_card: '补充信息',
  target_selector: '选择对象',
  result: '执行结果'
};
var ENTITY_TYPES = ['activity', 'market', 'community_note', 'external_source'];
var STAT_TYPES = ['stat_card', 'apply_summary', 'merchant_pending_apply'];
var NOTICE_TYPES = ['permission_denied', 'unsupported_action'];
export default {
  name: 'ChatRecordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [Number, String],
      default: null
    },
    userName: {
      type: String,
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      conversationLoading: false,
      conversations: [],
      conversationTotal: 0,
      conversationFrom: {
        page: 1,
        limit: 15
      },
      activeId: null,
      messageLoading: false,
      messages: [],
      messageTotal: 0,
      messageFrom: {
        page: 1,
        limit: 20
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      var name = this.userName ? "".concat(this.userName, "\uFF08UID\uFF1A").concat(this.uid, "\uFF09") : "UID\uFF1A".concat(this.uid);
      return "AI \u804A\u5929\u8BB0\u5F55 - ".concat(name);
    }
  },
  methods: {
    handleOpen: function handleOpen() {
      this.conversations = [];
      this.messages = [];
      this.activeId = null;
      this.conversationTotal = 0;
      this.messageTotal = 0;
      this.conversationFrom.page = 1;
      this.messageFrom.page = 1;
      this.loadConversations();
    },
    loadConversations: function loadConversations() {
      var _this = this;
      if (!this.uid) return;
      this.conversationLoading = true;
      aiStatisticsConversationListApi({
        uid: this.uid,
        startTime: this.startTime,
        endTime: this.endTime,
        page: this.conversationFrom.page,
        limit: this.conversationFrom.limit
      }).then(function (res) {
        _this.conversations = res && res.list || [];
        _this.conversationTotal = res && res.total || 0;
        _this.conversationLoading = false;
        if (_this.conversations.length && !_this.activeId) {
          _this.selectConversation(_this.conversations[0]);
        }
      }).catch(function () {
        _this.conversationLoading = false;
      });
    },
    loadMessages: function loadMessages() {
      var _this2 = this;
      if (!this.activeId) return;
      this.messageLoading = true;
      aiStatisticsConversationMessagesApi({
        conversationId: this.activeId,
        page: this.messageFrom.page,
        limit: this.messageFrom.limit
      }).then(function (res) {
        // 卡片与 Markdown 都在拿数据时一次性算好，模板里只做取值，
        // 避免在 v-for 里反复 JSON.parse / 正则匹配（一条会话可能有几十条消息）
        _this2.messages = (res && res.list || []).map(function (msg) {
          var rich = msg.role === 'assistant' && looksLikeMarkdown(msg.content);
          return _objectSpread(_objectSpread({}, msg), {}, {
            __cards: _this2.parseCards(msg.cardsJson),
            // 图片附件：后端已把 mediaJson 里的 mediaId 解析成可访问地址，
            // 前端只做归一化，不拼域名（换对象存储时不用改这里）
            __media: _this2.parseMedia(msg.mediaList),
            __rich: rich,
            __richHtml: rich ? markdownToHtml(msg.content) : ''
          });
        });
        _this2.messageTotal = res && res.total || 0;
        _this2.messageLoading = false;
      }).catch(function () {
        _this2.messageLoading = false;
      });
    },
    selectConversation: function selectConversation(item) {
      if (!item) return;
      this.activeId = item.id;
      this.messageFrom.page = 1;
      this.messages = [];
      this.messageTotal = 0;
      this.loadMessages();
    },
    handleConversationPageChange: function handleConversationPageChange(page) {
      this.conversationFrom.page = page;
      this.loadConversations();
    },
    handleMessagePageChange: function handleMessagePageChange(page) {
      this.messageFrom.page = page;
      this.loadMessages();
    },
    hasCards: function hasCards(msg) {
      var cards = msg && msg.cardsJson;
      return !!cards && cards !== 'null' && cards !== '[]' && cards !== '';
    },
    hasMedia: function hasMedia(msg) {
      return !!(msg && msg.__media && msg.__media.length);
    },
    /**
     * 归一化图片附件。
     *
     * <p>后端返回的每一项是 { mediaId, url, mimeType, sizeBytes, available }：
     * - available 且有 url → 正常缩略图（点击可放大预览）
     * - 否则 → 渲染「图片已过期」占位，明确告诉运营这张图已被保留期策略清理，
     *   而不是留一个裂图让人以为是前端 bug</p>
     */
    parseMedia: function parseMedia(list) {
      var _this3 = this;
      if (!Array.isArray(list)) return [];
      return list.filter(function (item) {
        return item && _typeof(item) === 'object';
      }).map(function (item, index) {
        return {
          __key: item.mediaId || "media-".concat(index),
          url: item.available && item.url ? item.url : '',
          mediaId: item.mediaId || '',
          mimeType: item.mimeType || '',
          sizeBytes: item.sizeBytes || 0,
          available: !!item.available && !!item.url,
          __sizeText: _this3.formatBytes(item.sizeBytes)
        };
      });
    },
    /**
     * 大图预览的地址列表。
     *
     * <p>只把可用的图放进去：如果把「已过期」的空地址也塞进 preview-src-list，
     * 预览层会出现一个打不开的黑屏，用户以为整组图都坏了。</p>
     */
    previewList: function previewList(media) {
      return (media || []).filter(function (m) {
        return m && m.available && m.url;
      }).map(function (m) {
        return m.url;
      });
    },
    /** 附件大小展示：运营排查时能一眼看出用户传的是缩略图还是原图。 */formatBytes: function formatBytes(value) {
      var bytes = Number(value || 0);
      if (!bytes) return '';
      if (bytes >= 1024 * 1024) return "".concat((bytes / 1024 / 1024).toFixed(1), "MB");
      if (bytes >= 1024) return "".concat(Math.round(bytes / 1024), "KB");
      return "".concat(bytes, "B");
    },
    /**
     * 解析并归一化 cards_json。
     *
     * <p>解析失败不抛错也不静默丢掉：返回一条错误卡片，
     * 运营至少能看出「这条历史数据有问题」，而不是以为 AI 什么都没回。</p>
     */
    parseCards: function parseCards(cardsJson) {
      var _this4 = this;
      if (!this.hasCards({
        cardsJson: cardsJson
      })) return [];
      var cards;
      try {
        cards = JSON.parse(cardsJson);
      } catch (e) {
        return [{
          __kind: 'notice',
          __typeLabel: '卡片数据异常',
          message: '该条消息的卡片 JSON 无法解析'
        }];
      }
      if (!Array.isArray(cards)) return [];
      return cards.filter(function (c) {
        return c && _typeof(c) === 'object';
      }).map(function (card) {
        return _this4.normalizeCard(card);
      });
    },
    /** 把一张卡片补上渲染所需的派生字段（类型名、封面、摘要、指标、标签）。 */normalizeCard: function normalizeCard(card) {
      var type = String(card.cardType || card.type || '');
      var normalized = _objectSpread(_objectSpread({}, card), {}, {
        __type: type,
        __typeLabel: TYPE_LABELS[type] || type || '卡片',
        __kind: this.cardKind(type),
        __cover: '',
        __gallery: [],
        __meta: '',
        __stats: [],
        __archives: [],
        __summaryRows: []
      });
      if (normalized.__kind === 'entity') {
        normalized.__gallery = this.imageList(card.image || card.cover || card.coverImage);
        normalized.__cover = normalized.__gallery[0] || '';
        normalized.__meta = this.cardMeta(card);
        normalized.__applyHint = card.applyHint || '';
        normalized.__applyTone = /结束|截止|取消|失效|删除/.test(normalized.__applyHint) ? 'info' : 'warning';
      } else if (normalized.__kind === 'stat') {
        normalized.__stats = this.statItems(card);
        normalized.__meta = card.merchantName ? "".concat(card.merchantName).concat(card.merId ? "\uFF08ID ".concat(card.merId, "\uFF09") : '') : card.status || '';
      } else if (normalized.__kind === 'action') {
        normalized.__meta = card.targetTitle || '';
        normalized.__summaryRows = this.summaryRows(card.summary);
        // 确认卡的 summary 里已经带了「报名档案 / 联系手机 / 经营商品」，
        // 再展开 archives 会把同样的信息重复一遍，因此仅在无 summary 时才列档案
        normalized.__archives = normalized.__summaryRows.length ? [] : (card.archives || []).map(function (arc) {
          return _objectSpread(_objectSpread({}, arc), {}, {
            __summary: [arc.phone, arc.goods].filter(Boolean).join(' · ')
          });
        });
      }
      return normalized;
    },
    cardKind: function cardKind(type) {
      if (ENTITY_TYPES.indexOf(type) !== -1) return 'entity';
      if (STAT_TYPES.indexOf(type) !== -1) return 'stat';
      if (NOTICE_TYPES.indexOf(type) !== -1) return 'notice';
      if (!type) return 'action';
      return 'action';
    },
    cardMeta: function cardMeta(card) {
      if (card.type === 'activity') return this.compactTime(card.time || (card.startTime ? "".concat(card.startTime, " \u8D77") : ''));
      if (card.type === 'market') return card.addressText || card.address || '';
      if (card.type === 'community_note') return card.author ? "".concat(card.author, " \xB7 \u644A\u53CB\u5730\u5E26") : '摊友地带';
      if (card.type === 'external_source') {
        var matched = String(card.url || '').match(/^https?:\/\/([^/]+)/i);
        return matched ? matched[1] : '';
      }
      return '';
    },
    statItems: function statItems(card) {
      if (card.scope === 'merchant' || card.type === 'merchant_pending_apply') {
        return [{
          label: '待审核报名',
          value: card.count === undefined ? 0 : card.count
        }];
      }
      return [{
        label: '待审核',
        value: card.pendingCount === undefined ? card.count || 0 : card.pendingCount
      }, {
        label: '累计报名',
        value: card.totalCount === undefined ? card.count || 0 : card.totalCount
      }];
    },
    /**
     * 封面归一化：{@code image} 可能是数组、JSON 数组字符串、逗号串或普通相对路径。
     * 后端三种都出现过，直接塞进 src 会得到非法 URL 并渲染成灰块。
     */
    /**
     * 确认卡的 summary 是一段「字段名 → 值」映射，不是字符串。
     * 直接 {{ card.summary }} 会渲染成 [object Object]，所以展开成行。
     */
    summaryRows: function summaryRows(summary) {
      if (!summary || _typeof(summary) !== 'object') return [];
      return Object.keys(summary).filter(function (key) {
        return summary[key] !== null && summary[key] !== undefined && summary[key] !== '';
      }).map(function (key) {
        return {
          key: key,
          value: _typeof(summary[key]) === 'object' ? JSON.stringify(summary[key]) : String(summary[key])
        };
      });
    },
    imageList: function imageList(value) {
      if (!value) return [];
      var raw = value;
      if (typeof raw === 'string') {
        var text = raw.trim();
        if (!text) return [];
        if (text.charAt(0) === '[') {
          try {
            raw = JSON.parse(text);
          } catch (e) {
            raw = [text];
          }
        } else {
          raw = [text];
        }
      }
      if (!Array.isArray(raw)) return [];
      return raw.map(function (item) {
        return String(item || '').trim();
      }).filter(Boolean).map(function (item) {
        return /^https?:\/\//i.test(item) ? item : "".concat(ASSET_HOST, "/").concat(item.replace(/^\/+/, ''));
      });
    },
    /**
     * 时间压缩：{@code 2026-10-30 00:00 至 2027-12-30 00:00} → {@code 2026/10/30 – 12/30}。
     * 活动都是按天报名，去掉时分并合并重复年份后刚好一行放下。
     */
    compactTime: function compactTime(value) {
      var text = String(value || '').trim();
      if (!text) return '';
      var dates = [];
      var pattern = /(\d{4})-(\d{2})-(\d{2})/g;
      var matched = pattern.exec(text);
      while (matched) {
        dates.push({
          year: matched[1],
          month: matched[2],
          day: matched[3]
        });
        matched = pattern.exec(text);
      }
      if (!dates.length) return text;
      var full = function full(item) {
        return "".concat(item.year, "/").concat(item.month, "/").concat(item.day);
      };
      var short = function short(item) {
        return "".concat(item.month, "/").concat(item.day);
      };
      if (dates.length >= 2) {
        var sameYear = dates[0].year === dates[1].year;
        return "".concat(full(dates[0]), " \u2013 ").concat(sameYear ? short(dates[1]) : full(dates[1]));
      }
      return "".concat(full(dates[0])).concat(text.indexOf('起') >= 0 ? ' 起' : '');
    },
    formatNumber: function formatNumber(value) {
      if (value === null || value === undefined || value === '') return '0';
      var num = Number(value);
      if (isNaN(num)) return String(value);
      return num.toLocaleString('zh-CN');
    }
  }
};